export default __webpack_public_path__ + "static/assets/med_capsule_V_tran_01_m.1de2aefb.png";